import { LitElement, html, TemplateResult } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { ButtonID, FontSizeChangeButton, FontSizeChangeValue } from '../types';
import { styles } from '../view/styles';

/**
 * @summary Component used to change font size of the text in webcomponents
 * @tag gz-font-size-changer
 */
@customElement('gz-font-size-changer')
export class GzFontSizeChangerWebComponent extends LitElement {
  @property({ type: String, reflect: true })
  private selectedButtonValue = FontSizeChangeValue.DEFAULT_SIZE;

  private buttons: FontSizeChangeButton[] = [
    {
      id: ButtonID.DECREASE_SIZE,
      fontSize: '12',
      value: FontSizeChangeValue.DECREASE_SIZE,
    },
    {
      id: ButtonID.DEFAULT_SIZE,
      fontSize: '14',
      value: FontSizeChangeValue.DEFAULT_SIZE,
    },
    {
      id: ButtonID.INCREASE_SIZE,
      fontSize: '16',
      value: FontSizeChangeValue.INCREASE_SIZE,
    },
  ];

  static get styles() {
    return styles;
  }

  render(): TemplateResult {
    return html`
      <div class="d-flex buttons-wrapper">${this.buttons.map(button => this.renderFontSizeChangeButton(button))}</div>
    `;
  }

  private renderFontSizeChangeButton(button: FontSizeChangeButton): TemplateResult {
    const style = `font-size: ${button.fontSize}px;`;
    const classes = {
      selected: button.value === this.selectedButtonValue,
    };

    return html`<button
      @click="${event => this.handleButtonClick(event)}"
      value="${button.value}"
      style=${style}
      class="${classMap(classes)}"
    >
      A
    </button>`;
  }

  private handleButtonClick(event: MouseEvent): void {
    let buttonElement = event.target as HTMLButtonElement;
    if (buttonElement.value) {
      this.selectedButtonValue = buttonElement.value as FontSizeChangeValue;
      document.documentElement.style.setProperty('--dynamic-font-size-changer', buttonElement.value);
      document.documentElement.style.setProperty('--dynamic-small-font-size-changer', buttonElement.value);

      if (buttonElement.value == FontSizeChangeValue.DECREASE_SIZE) {
        document.documentElement.style.setProperty(
          '--dynamic-small-font-size-changer',
          FontSizeChangeValue.DEFAULT_SIZE
        );
      }
    }
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'gz-font-size-changer': GzFontSizeChangerWebComponent;
  }
}
